import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { components } from '../../Utils/ReactSelectComponents';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import NegotiationLotAPI from '../../../API/NegotiationLotsAPI';
import DropdownListAPI from '../../../API/DropdownListAPI';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';
import { NEW_CARS_BRANDS } from '../../../Utils/Constants';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import MaskedInput from 'react-text-mask';
import { ConvertToBool } from '../../Utils/GenericFunctions';


const modalStyles = theme => ({
  paperNewLot: {
    position: 'absolute',
    width: '70%',
    minWidth: 240,
    backgroundColor: theme.palette.background.paper
  },
  toolbarRoot: {
    padding: 0,
    backgroundColor: theme.palette.primary[500]
  },
  titleHead: {
    margin: '4px 12px',
    color: '#ffffff'
  },
  iconRight: {
    position: 'absolute',
    right: '12px',
    marginTop: '40px'
  },
  formRoot: {
    flexGrow: 1,
    margin: '12px'
  },
  group: {
    display: 'inline-block'
  },
  width100: {
    width: '100%'
  },
  footer: {
    display: 'flex',
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    zIndex: 1
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  alignTextfield: {
    paddingTop: '6px'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  },
  chip: {
    margin: theme.spacing.unit / 6
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  }
});

function getModalPosition() {
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
}

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      fixedDecimalScale
      decimalScale={0}
      maxLength={3}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy', { maxYear: new Date().getFullYear() });

const DateMask = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={' '}
    />
  );
}
DateMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class NegotiationNewLotModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      loading: false,
      success: false,
      brand: {},
      model: {},
      saleChannel: [],
      deliveryDeadline: '',
      a1Value: 'no',
      debitValue: 'no',
      licensePlatePlan: '',
      lotLPPT: '',
      vehicleLocation: '',
      formalizationDate: '',
      observations: '',
      openError: false,
      alertMessage: '',
      brandData: [],
      saleChannelData: []
    };
  }

  handleOpen = () => {
    this.setState({ openModal: true });
    this.getAllBrandsAndSaleChannels();
  };

  getAllBrandsAndSaleChannels() {
    const dropdownListDataAPI = new DropdownListAPI();
    Promise.all([dropdownListDataAPI.getAllBrands(NEW_CARS_BRANDS), dropdownListDataAPI.getAllSalesChannels()]).then((response) => {
      this.setState({
        brandData: response[0].data,
        saleChannelData: response[1].data,
        loading: false
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
  };

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleChangeBrand = brandValue => {
    this.setState({ brand: brandValue, model: {} });
    const dropdownListDataAPI = new DropdownListAPI();
    dropdownListDataAPI.getAllCarModelsByBrand(brandValue.value, NEW_CARS_BRANDS).then((response) => {
      this.setState({
        carModelData: response.data
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      loading: false,
      success: false
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  parseStateForSubmit(estado) {
    let salesChannelsIds = [];
    estado.saleChannel.forEach((item) => {
      salesChannelsIds.push(item.value);
    });

    return {
      BrandId: estado.brand.value,
      CarModelId: estado.model.value,
      DeliveryDeadline: estado.deliveryDeadline,
      SaleChannelIds: salesChannelsIds,
      WithA1: ConvertToBool(estado.a1Value),
      AmountDebited: ConvertToBool(estado.debitValue),
      LicensePlatePlan: estado.licensePlatePlan,
      VehicleLocation: estado.vehicleLocation,
      LotLPPT: estado.lotLPPT,
      FormalizationDate: estado.formalizationDate,
      Observations: estado.observations
    }
  }

  handleSubmit = () => {
    const negotiationLotAPI = new NegotiationLotAPI();
    this.setState({ loading: true })
    let negotiationLotDTO = this.parseStateForSubmit(this.state);
    negotiationLotAPI.createNegotiationLot(negotiationLotDTO).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          brand: {},
          model: {},
          saleChannel: [],
          deliveryDeadline: '',
          a1Value: 'no',
          debitValue: 'no',
          licensePlatePlan: '',
          lotLPPT: '',
          vehicleLocation: '',
          formalizationDate: '',
          observations: '',
        });
        this.handleClose()
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose()
    });
  };


  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });

    return (
      <div>

        <Tooltip title='Novo Lote' placement='bottom' >
          <Button variant='fab' color='primary' onClick={this.handleOpen} className={classNames(classes.button, classes.buttonSize)}>
            <AddIcon />
          </Button>
        </Tooltip>

        <Modal open={this.state.openModal} onClose={this.handleClose} disableAutoFocus={true}>
          <Paper style={getModalPosition()} className={classes.paperNewLot}>

            <Paper>
              <Toolbar className={classes.toolbarRoot} >
                <Typography variant='title' className={classes.titleHead}>
                  NOVO LOTE
                </Typography>
              </Toolbar>
            </Paper>

            <form className={classes.formRoot}>
              <Grid container spacing={8}>

                <Grid item xs={12} sm={6}>
                  <Grid container justify='center'>
                    <div className={classes.width100}>
                      <InputLabel htmlFor='brand'>
                        MARCA
                      </InputLabel>
                      <ReactSelect
                        classes={classes}
                        options={this.state.brandData}
                        components={components}
                        value={this.state.brand}
                        onChange={this.handleChangeBrand}
                        placeholder=''
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container justify='center'>
                    <div className={classes.width100}>
                      <InputLabel htmlFor='model'>
                        MODELO
                      </InputLabel>
                      <ReactSelect
                        classes={classes}
                        options={this.state.carModelData}
                        components={components}
                        value={this.state.model}
                        onChange={this.handleChangeSelect('model')}
                        placeholder=''
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container justify='center'>
                    <div className={classes.width100}>
                      <InputLabel htmlFor='saleChannel'>
                        CANAL DE VENDA
                      </InputLabel>
                      <ReactSelect
                        classes={classes}
                        options={this.state.saleChannelData}
                        components={components}
                        value={this.state.saleChannel}
                        onChange={this.handleChangeSelect('saleChannel')}
                        placeholder=''
                        isMulti
                        closeMenuOnSelect={false}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='deliveryDeadline'
                    label='PRAZO DE ENTREGA (dias úteis)'
                    fullWidth
                    className={classes.alignTextfield}
                    value={this.state.deliveryDeadline}
                    onChange={this.handleChange('deliveryDeadline')}
                    InputProps={{ inputComponent: InputNumber }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='licensePlatePlan'
                    label='PLANO DE MATRÍCULAS'
                    fullWidth
                    inputProps={{ maxLength: 50 }}
                    value={this.state.licensePlatePlan}
                    onChange={this.handleChange('licensePlatePlan')}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='location'
                    label='LOCALIZAÇÃO VEÍCULOS'
                    fullWidth
                    inputProps={{ maxLength: 200 }}
                    value={this.state.vehicleLocation}
                    onChange={this.handleChange('vehicleLocation')}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='lotLPPT'
                    label='LOTE LPPT'
                    fullWidth
                    inputProps={{ maxLength: 200 }}
                    value={this.state.lotLPPT}
                    onChange={this.handleChange('lotLPPT')}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='formalizationDate'
                    label='DATA FORMALIZAÇÃO (dd/mm/aaaa)'
                    fullWidth
                    type='text'
                    InputProps={{
                      inputComponent: DateMask,
                      value: this.state.formalizationDate,
                      pipe: autoCorrectedDatePipe,
                      placeholder: '',
                      onChange: this.handleChange('formalizationDate'),
                      guide: false
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container spacing={8} justify='flex-start' alignItems='center'>
                    <Grid item>
                      <FormLabel component='legend'>
                        AQUISIÇÃO C/ A1:
                      </FormLabel>
                    </Grid>
                    <Grid item>
                      <FormControl component='fieldset'>
                        <RadioGroup
                          aria-label='acquisitionA1'
                          name='acquisitionA1'
                          className={classes.group}
                          value={this.state.a1Value}
                          onChange={this.handleChange('a1Value')}
                        >
                          <FormControlLabel name='yes' value='yes' control={<Radio color='primary' />} label='Sim' />
                          <FormControlLabel name='no' value='no' control={<Radio color='primary' />} label='Não' />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container spacing={8} justify='flex-start' alignItems='center'>
                    <Grid item>
                      <FormLabel component='legend'>
                        VALOR DEBITADO:
                      </FormLabel>
                    </Grid>
                    <Grid item>
                      <FormControl component='fieldset'>
                        <RadioGroup
                          aria-label='debitValue'
                          name='debitValue'
                          className={classes.group}
                          value={this.state.debitValue}
                          onChange={this.handleChange('debitValue')}
                        >
                          <FormControlLabel name='yes' value='yes' control={<Radio color='primary' />} label='Sim' />
                          <FormControlLabel name='no' value='no' control={<Radio color='primary' />} label='Não' />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    id='obs'
                    label='OBSERVAÇÕES'
                    margin='normal'
                    fullWidth
                    multiline
                    rows='1'
                    rowsMax='3'
                    inputProps={{ maxLength: 1000 }}
                    value={this.state.observations}
                    onChange={this.handleChange('observations')}
                  />
                </Grid>
              </Grid>

              <Toolbar className={classes.footer}>
                <div className={classes.iconRight}>
                  <Tooltip title='Cancelar' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClose}>
                      <CloseIcon />
                    </Button>
                  </Tooltip>

                  <Tooltip title='Guardar' placement='bottom' >
                    <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.handleSubmit}>
                      {success ? <CheckIcon /> : <SaveIcon />}
                    </Button>
                  </Tooltip>
                  {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                </div>
              </Toolbar>

            </form>
          </Paper>
        </Modal>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    );
  }
}

NegotiationNewLotModal.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(modalStyles)(NegotiationNewLotModal);


// WEBPACK FOOTER //
// ./src/components/Negotiation/Lots/NegotiationNewLotModal.js